import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p>
            As a{" "}
            <b className="purple">
              Software Development Engineer in Test (SDET)
            </b>{" "}
            at <b className="purple">Ford Motor Company</b>, I focus on user
            acceptance testing for OTA updates, ADAS validation, and automation
            of test workflows. My background spans automotive, finance, and
            insurance, with experience in diagnostics, RPA, and full-stack
            development.
            <br />
            <br />
            With a <b className="purple">BS in Computer Science</b> from the
            University of Michigan-Dearborn, I bring a solid foundation in
            <i>
              <b className="purple"> Python, JavaScript, and C#</b>
            </i>
            , and a passion for building secure, efficient solutions that
            improve real-world systems.
            <br />
            <br />
            I’m currently expanding my skills in
            <i>
              <b className="purple">
                {" "}
                automation, diagnostics, and computer vision
              </b>
            </i>
            , using tools like
            <i>
              <b className="purple"> OpenCV and Power Automate</b>
            </i>
            .
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
